import { SectionCompletionState } from '@assessments/shared'
import type { BadgeTone } from '@/components/ui/badge'

/**
 * One vocabulary for section completion, shared by the overview rows and the sidebar
 * rail. Each map is a total Record, so adding a state fails the type-check here rather
 * than silently rendering an unstyled row in whichever surface was forgotten.
 */
export const SECTION_STATE_LABEL: Record<SectionCompletionState, string> = {
  [SectionCompletionState.NotStarted]: 'Not started',
  [SectionCompletionState.InProgress]: 'In progress',
  [SectionCompletionState.Complete]: 'Complete',
}

export const SECTION_STATE_TONE: Record<SectionCompletionState, BadgeTone> = {
  [SectionCompletionState.NotStarted]: 'neutral',
  [SectionCompletionState.InProgress]: 'progress',
  [SectionCompletionState.Complete]: 'success',
}

/** Sidebar completion mark: a filled check for done, an outline otherwise. */
export const SECTION_STATE_MARK: Record<
  SectionCompletionState,
  { className: string; checked: boolean }
> = {
  [SectionCompletionState.NotStarted]: {
    className: 'border-2 border-dashed border-inverse/35',
    checked: false,
  },
  [SectionCompletionState.InProgress]: {
    className: 'border-2 border-progress bg-transparent',
    checked: false,
  },
  [SectionCompletionState.Complete]: { className: 'bg-success', checked: true },
}
